import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { shift_pressed } from '../../keypress';
import { abort_drawing_edge_on_face, add_edge_action } from '../../scene';
import { disabled } from '../../state/operations/add-edge';
import add_edge_svg from '../../../assets/img/SVG_icons/Top/create_model/add_edge.svg';
import { img } from '@phi/components';
import AddEdgeTooltip from './AddEdgeTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const AddEdgeIcon = add_edge_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Add Edge';
        }
    },

    methods: {
        onClick() {
            if (disabled.value)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'free')
                this.subscriptions.show_view_only_modal();
            else if (this.state.drawing_edge)
                abort_drawing_edge_on_face();
            else
                add_edge_action(shift_pressed());
        },

        onLongClick() {
            if (disabled.value)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'free')
                this.subscriptions.show_view_only_modal();
            else if (this.state.drawing_edge)
                abort_drawing_edge_on_face();
            else
                add_edge_action(true);
        },
    },

    render() {
        return h(BarButton, {
            disabled: disabled.value,
            selected: this.state.tut_stage === 2,
            active: this.state.drawing_edge,
            id: 'add-edge-button',
            wrapperId: 'add-edge-wrapper',
            tippy: 'bottom',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            help: 'add_edge',
        }, {
            label: () => '+Edge',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(add_edge_svg, this.alt),
            tooltip: AddEdgeTooltip,
        });
    },
});
